import React from 'react';
import { StyledScrollBox } from './ScrollBox.style';

const ScrollBox = function ScrollBox({ height, children, color }) {
  return (
      <StyledScrollBox className="scroll-box" height={height} color={color}>
        {children}
      </StyledScrollBox>
  );
};

export default ScrollBox;
